import ColorChip from "../../UI/chips/ColorChip";
import labels from "../../../utils/labels";
import RowCell from "../../UI/table/RowCell";

const TeamSettingsRow = ({
  colorHex,
  chipColor,
  teamName,
  grouped,
}: {
  colorHex: string;
  chipColor: string;
  teamName: string;
  grouped: boolean;
}) => {
  return (
    <li className="flex">
      <RowCell width={174}>
        <ColorChip text={colorHex} classes="uppercase" color={chipColor} />
      </RowCell>

      <RowCell>
        <p>{teamName}</p>
      </RowCell>

      <RowCell>
        <input
          type="checkbox"
          checked={grouped}
          disabled
          aria-label={labels.groupEmployeesInTeams}
        />
      </RowCell>
    </li>
  );
};

export default TeamSettingsRow;
